var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultFilter',{attrs:{"refFilter":"CalendarMovementFilter","model":_vm.filter,"filters":_vm.filters,"showRangeFilter":false,"showExpansion":false,"loading":_vm.loading},on:{"search":function($event){return _vm.search(_vm.filter)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }